'use es6';

import pipe from 'transmute/pipe';
import { getMessage } from './widgetDataGetters';
import { getGdprConsentToCommunicateEnabled } from '../../message/operators/messageGetters';
export const gdprConsentToCommunicateEnabled = pipe(getMessage, getGdprConsentToCommunicateEnabled);